import {
  LinkedRouteRef,
  UnlinkedWorkRouteRef,
  WorkedInRouteRef,
} from '../types/surveillanceRoute';

/**
 * Recorridos cuya patrulla hizo esta actuación o accidente, según el back
 * (`workOrderIds` de cada recorrido ligado a la OT padre). Si la OT pierde el
 * recorrido, deja de salir: se recalcula en cada lectura.
 */
export const routesForWork = (
  routes: LinkedRouteRef[],
  workId: string
): WorkedInRouteRef[] =>
  routes
    .filter((route) => (route.workOrderIds ?? []).includes(workId))
    .map(({ id, roid, name }) => ({ id, roid, name }));

/**
 * Spec § 16: patrullas sin vincular que hicieron esta actuación o accidente
 * (`unlinkedWorkRoutes` de la OT padre). Al ligar el recorrido, deja de salir
 * aquí y sale en `routesForWork`.
 *
 * Cada una lleva `workCount`: cuántos trabajos de la OT hizo ese recorrido. El
 * vínculo es de la OT entera, así que ligar desde una etiqueta pone en verde
 * todos a la vez; el menú lo avisa antes del toque (revisión del usuario 28/09).
 */
export const unlinkedRoutesForWork = (
  unlinked: UnlinkedWorkRouteRef[],
  workId: string
): UnlinkedWorkRouteRef[] =>
  unlinked
    .filter((ref) => ref.workOrderId === workId)
    .map((ref) => ({
      ...ref,
      workCount: new Set(
        unlinked
          .filter((other) => other.routeId === ref.routeId)
          .map((other) => other.workOrderId)
      ).size,
    }));
